import { getSocialLinks, SOCIAL_ICONS } from "@/lib/social-links";
import { cn } from "@/lib/utils";

interface ContactSocialLinksProps {
  className?: string;
  premium?: boolean;
}

export function ContactSocialLinks({
  className,
  premium = false,
}: ContactSocialLinksProps) {
  const links = getSocialLinks();

  if (links.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap gap-2", className)}>
      {links.map(({ platform, href, label }) => {
        const Icon = SOCIAL_ICONS[platform];
        return (
          <a
            key={platform}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className={cn(
              "flex h-10 w-10 items-center justify-center rounded-full border transition-all duration-300",
              premium
                ? "border-[var(--contact-border)] bg-[var(--contact-surface)] text-[var(--contact-primary)] hover:-translate-y-0.5 hover:border-[var(--contact-primary)]/30 hover:bg-[var(--contact-surface-muted)] hover:shadow-md"
                : "border-border bg-surface-elevated text-primary hover:border-primary/40 hover:bg-surface-accent"
            )}
          >
            <Icon size={16} aria-hidden />
          </a>
        );
      })}
    </div>
  );
}
